import { lazy } from 'react';

export const PlayerRemoveStatusOverwriteForm = lazy(
  () => import('./PlayerRemoveStatusOverwriteForm'),
);
